export const ABOUT_TAB_FRAGMENT = 'about';
export const TERMS_AND_CONDITIONS_TAB_FRAGMENT = 'termsandconditions';
export const CANCELLATION_POLICY_TAB_FRAGMENT = 'cancellationpolicy';
export const DATA_POLICY_TAB_FRAGMENT = 'datapolicy';
export const TAKE_BACK_INFORMATION_TAB_FRAGMENT = 'takebackinformation';
export const ALL_PRODUCTS_TAB_FRAGMENT = 'allproducts';
